import { render, staticRenderFns } from "./ClinicalArc.vue?vue&type=template&id=3699ec7f&scoped=true"
import script from "./ClinicalArc.vue?vue&type=script&lang=js"
export * from "./ClinicalArc.vue?vue&type=script&lang=js"
import style0 from "./ClinicalArc.vue?vue&type=style&index=0&id=3699ec7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699ec7f",
  null
  
)

export default component.exports